module.exports = "<div ng-if=\"leaseContractNumberIsAvailable()\">\n    <div\n        gw-pl-input-ctrl\n        model=\"vehicle.additionalInterest.leaseContractNumber\"\n        label=\"{{'quoteandbind.mfp.directives.templates.mfp-leasing-information.referenceNumber' | translate}}\">\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/quoteandbind/mfp/directives/templates/mfp-leasing-information.html
// module id = 630
// module chunks = 0